import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import _ from 'lodash';
import TablePaginationActions from '../TablePaginationActions';
import { LIST_PAGE_COUNT } from '../../data/common';
import PointsTableRow from './PointsTableRow';

const PointsTable = (props) => {
  const {
    points,
    pointTotal,
    viewPoint,
    deletePoint,
    isLoading,
    pageNum,
    setPageNum,
  } = props;

  return (
    <TableContainer component={Box}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>顧客</TableCell>
            <TableCell>類型</TableCell>
            <TableCell>點數</TableCell>
            <TableCell>發票金額</TableCell>
            <TableCell>狀態</TableCell>
            <TableCell>日期</TableCell>
            <TableCell>建立者</TableCell>
            <TableCell align="right">功能</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {_.map(points, (point) => (
            <PointsTableRow
              key={point.id}
              point={point}
              viewPoint={viewPoint}
              deletePoint={deletePoint}
              isLoading={isLoading}
            />
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[LIST_PAGE_COUNT]}
              colSpan={10}
              count={pointTotal}
              rowsPerPage={LIST_PAGE_COUNT}
              page={pageNum - 1}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onChangePage={(event, currentPage) => {
                setPageNum(currentPage + 1);
              }}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default PointsTable;
